import styled, { css } from 'styled-components';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: var(--input);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 0 10px;
  width: 100%;
  height: 47px;
  color: var(--title);
  font-size: 14px;
  box-sizing: border-box;


  display: flex;
  align-items: center;

  & + div {
    margin-top: 32px;
  }

  ${props =>
    props.isErrored &&
    css`
      border: 2px solid var(--primary);
      color: var(--primary);
      height: 51px;
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: var(--line-table);
    `}

  ${props => props.isFilled && css``}



  input {
  font-size: 14px;
  box-sizing: border-box;
    flex: 1;
    background: transparent;
    border: 0;
    color: var(--title);

    &::placeholder {
      color: var(--secondary);
    }

    svg {
      margin-right: 16px;
    }
  }
`;

export const Error = styled.div`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }
`;
